<template>
  <img :src="logoSrc" alt="Coach Catalyst" />
</template>

<script>
  export default {
    name: 'Logo',
    props: {
      type: {
        type: String,
        default: 'Long',
      },
    },
    data() {
      return {
        sources: {
          LONG: require('images/logo_one_line.png'),
          ICON: require('images/CC-logo-light.png'),
          ICON_DARK: require('images/cc-logo-dark.png'),
        },
      };
    },
    computed: {
      logoSrc() {
        return this.sources[this.type] || this.sources.short;
      },
    },
  };
</script>